export default __webpack_public_path__ + "static/media/vsp-04203.0461ea48.jpg";